import { Grid } from '@mui/material';
import FieldText from '../../../../../components/general/fields/fieldText';
import Loading from '../../../../../components/general/loadings/loading';
import { Checkbox } from '../../../../../components/general/fields/checkbox';

import { InitialCausalityInfoProps } from './props';
import { useInitialCausalityData } from './hook';

export const InitialCausalityInfo = ({
    loading,
    initialCausality,
}: InitialCausalityInfoProps) => {
    const { formik } = useInitialCausalityData(initialCausality);

    return loading ? (
        <Loading />
    ) : (
        <Grid
            container
            spacing={{ xs: 1.5, md: 1.5 }}
            columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
        >
            <Grid item xs={12}>
                <FieldText
                    label="Nombre"
                    name="name"
                    size="small"
                    value={formik.values.name || ''}
                    disabled
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Producto"
                    name="product"
                    size="small"
                    value={(formik.values.product as string) || ''}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Tipo"
                    name="typePqr"
                    size="small"
                    value={(formik.values.typePqr as string) || ''}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Motivo"
                    name="motive"
                    size="small"
                    value={(formik.values.motive as string) || ''}
                />
            </Grid>
            {formik.values.submotive1 && (
                <Grid item xs={12} sm={6} md={4}>
                    <FieldText
                        label="Submotivo 1"
                        name="submotive1"
                        size="small"
                        value={(formik.values.submotive1 as string) || ''}
                    />
                </Grid>
            )}
            {formik.values.submotive2 && (
                <Grid item xs={12} sm={6} md={4}>
                    <FieldText
                        label="Submotivo 2"
                        name="submotive2"
                        size="small"
                        value={(formik.values.submotive2 as string) || ''}
                    />
                </Grid>
            )}
            {formik.values.submotive3 && (
                <Grid item xs={12} sm={6} md={4}>
                    <FieldText
                        label="Submotivo 3"
                        name="submotive3"
                        size="small"
                        value={(formik.values.submotive3 as string) || ''}
                    />
                </Grid>
            )}
            {formik.values.submotive4 && (
                <Grid item xs={12} sm={6} md={4}>
                    <FieldText
                        label="Submotivo 4"
                        name="submotive4"
                        size="small"
                        value={(formik.values.submotive4 as string) || ''}
                    />
                </Grid>
            )}
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Categoría"
                    name="category"
                    size="small"
                    value={formik.values.category || ''}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Proceso"
                    name="process"
                    size="small"
                    value={formik.values.process || ''}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Subproceso"
                    name="subprocess"
                    size="small"
                    value={formik.values.subprocess || ''}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="NO. Riesgo"
                    name="riskId"
                    size="small"
                    value={formik.values.riskId || ''}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Riesgo"
                    name="risk"
                    size="small"
                    value={formik.values.risk || ''}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Consecuencia"
                    name="consequence"
                    size="small"
                    value={formik.values.consequence || ''}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Impacto del riesgo"
                    name="riskImpact"
                    size="small"
                    value={formik.values.riskImpact || ''}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Motivo de reclamación SFC"
                    name="sfcMotiveClaim"
                    size="small"
                    value={formik.values.sfcMotiveClaim || ''}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Subcuenta SFC"
                    name="sfcSubaccount"
                    size="small"
                    value={formik.values.sfcSubaccount || ''}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Motivo [SECTOR - FASECOLDA]"
                    name="sfcMotive"
                    size="small"
                    value={formik.values.sfcMotive || ''}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Submotivo [SECTOR - FASECOLDA]"
                    name="sfcSubmotive"
                    size="small"
                    value={formik.values.sfcSubmotive || ''}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Código motivo quejas sector SFC(Nuevo)"
                    name="sfcMotiveIdComplaint"
                    size="small"
                    value={formik.values.sfcMotiveIdComplaint || ''}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Código motivo quejas sector SFC(Anterior)"
                    name="sfcMotiveIdComplaintOld"
                    size="small"
                    value={formik.values.sfcMotiveIdComplaintOld || ''}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Tipo de queja"
                    name="typeComplaint"
                    size="small"
                    value={(formik.values.typeComplaint as string) || ''}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Nombre Motivo de Queja SFC"
                    name="motiveName"
                    size="small"
                    value={formik.values.motiveName || ''}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Descripción Motivo de Quejas SFC"
                    name="motiveDescription"
                    size="small"
                    value={formik.values.motiveDescription || ''}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Ramo técnico"
                    name="technicalBranch"
                    size="small"
                    value={(formik.values.technicalBranch as string) || ''}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Producto unificado"
                    name="unifiedProduct"
                    size="small"
                    value={(formik.values.unifiedProduct as string) || ''}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Tipo de motivo"
                    name="typeMotive"
                    size="small"
                    value={(formik.values.typeMotive as string) || ''}
                />
            </Grid>
            <Grid item xs={12} sm={4}>
                <Checkbox
                    label="Activo"
                    checked={Boolean(formik.values.active)}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Observación versión 1"
                    name="observationV1"
                    size="small"
                    value={formik.values.observationV1 || ''}
                />
            </Grid>
        </Grid>
    );
};
